import { useTranslation } from 'react-i18next'
import { cn } from '@/shared/lib/utils'
import { LanguageSwitcher } from './LanguageSwitcher'
import { Text } from '@asus-common/fe-ui-shadcn'

interface AppFooterProps {
  showLanguageSelector?: boolean
  className?: string
}

export function AppFooter({
  showLanguageSelector = true,
  className,
}: AppFooterProps) {
  const { t } = useTranslation('auth-common')
  const year = new Date().getFullYear()

  return (
    <footer
      className={cn(
        'flex w-full items-center justify-between bg-(--blue-3-1) px-12 py-4',
        className,
      )}
    >
      <Text className="text-muted-foreground" fontSize="md" fontWeight="medium">
        {t('footer.copyright', { year })}
      </Text>
      {showLanguageSelector && (
        <div className="w-88">
          <LanguageSwitcher />
        </div>
      )}
    </footer>
  )
}
